import React from 'react';
import IconButton from '@mui/material/IconButton';

const activeSx = {
  backgroundColor: 'primary.main',
  color: 'white',
  '&:hover': {
    backgroundColor: 'primary.light',
  },
};

const defaultSx = {
  color: 'grey.900',
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: 'white',
  },
};

function BtnEtage({ onClick, active, children, sx = {}, className = '' }) {
  return (
    <IconButton
      className={className}
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '38px',
        height: '38px',
        border: '1px solid',
        borderColor: 'grey.600',
        fontFamily: 'font-family-dinCondensedBold',
        fontSize: '1.1rem',
        ...sx,
        ...(active ? activeSx : defaultSx),
      }}
    >
      {children}
    </IconButton>
  );
}

export default BtnEtage;
